module.exports = __webpack_public_path__ + "img/footer-bg.d02c370e.svg";